export default __webpack_public_path__ + "static/media/whiteCloseIcon.e90904de.svg";